import React from "react";
import "../styles/m3d-vantagens.css";

import HeroSection from "../components/m3d-vantagens/HeroSection";
import ComoFunciona from "../components/m3d-vantagens/ComoFunciona";
import ComoResgatar from "../components/m3d-vantagens/ComoResgatar";
import PremiosSection from "../components/m3d-vantagens/PremiosSection";
import CtaFinal from "../components/m3d-vantagens/CtaFinal";
import Footer from '../components/footerm3d';

export default function M3DVantagens() {
  return (
    <div className="m3d-vantagens">
      <HeroSection />
      <ComoFunciona />
      <ComoResgatar />
      <PremiosSection />
      <CtaFinal />
      <Footer />
    </div>
  );
}

/* Old dropdown/nav helpers removed; page now renders composed components */
